import React, { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Link2 } from "lucide-react";

const TOOLS = [
  { cmd: "bold", icon: Bold, label: "Negrita", tid: "editor-bold" },
  { cmd: "italic", icon: Italic, label: "Cursiva", tid: "editor-italic" },
  { cmd: "underline", icon: Underline, label: "Subrayado", tid: "editor-underline" },
  { cmd: "insertUnorderedList", icon: List, label: "Lista", tid: "editor-ul" },
  { cmd: "insertOrderedList", icon: ListOrdered, label: "Lista numerada", tid: "editor-ol" },
];

export const RichTextEditor = ({ value, onChange, placeholder }) => {
  const ref = useRef(null);
  const mounted = useRef(false);

  useEffect(() => {
    // Contenido inicial una sola vez: si React re-escribiera el HTML en cada tecla,
    // el cursor saltaría al inicio.
    if (!mounted.current && ref.current) {
      mounted.current = true;
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const exec = (cmd) => {
    ref.current?.focus();
    document.execCommand(cmd, false, null);
    onChange(ref.current?.innerHTML || "");
  };

  const addLink = () => {
    const url = window.prompt("Pega el enlace (https://...)");
    if (!url) return;
    ref.current?.focus();
    document.execCommand("createLink", false, url);
    onChange(ref.current?.innerHTML || "");
  };

  return (
    <div className="rounded-xl border border-neutral-300 overflow-hidden focus-within:border-[#00AEEF] transition-colors">
      <div className="flex items-center gap-1 px-2 py-1.5 bg-neutral-50 border-b border-neutral-200">
        {TOOLS.map((t) => (
          <button
            key={t.cmd}
            type="button"
            data-testid={t.tid}
            title={t.label}
            onClick={() => exec(t.cmd)}
            className="w-8 h-8 rounded-lg text-neutral-600 hover:bg-white hover:text-[#0092CC] hover:shadow-sm flex items-center justify-center transition-all"
          >
            <t.icon size={15} />
          </button>
        ))}
        <button
          type="button"
          data-testid="editor-link"
          title="Insertar enlace"
          onClick={addLink}
          className="w-8 h-8 rounded-lg text-neutral-600 hover:bg-white hover:text-[#0092CC] hover:shadow-sm flex items-center justify-center transition-all"
        >
          <Link2 size={15} />
        </button>
      </div>
      <div
        ref={ref}
        data-testid="campaign-body-editor"
        contentEditable
        suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        data-placeholder={placeholder}
        className="min-h-[160px] max-h-[320px] overflow-y-auto px-3.5 py-3 text-sm leading-relaxed outline-none empty:before:content-[attr(data-placeholder)] empty:before:text-neutral-400 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-[#0092CC] [&_a]:underline"
      />
    </div>
  );
};
